import axios from 'axios';
import { API_URL, ChatBaseUrl, IMAGE_BASE_URL } from '../../../redux/api/http-common';

const http = axios.create({
  baseURL: API_URL,
  headers: {
    // "Content-type": "application/json",
    'Content-Type':
      'multipart/form-data; boundary=AaB03x' +
      '--AaB03x' +
      'Content-Disposition: file' +
      'Content-Type: png' +
      'Content-Transfer-Encoding: binary' +
      '...data... ' +
      '--AaB03x--',
    Accept: 'application/json',
    type: 'formData',
    'X-Robots-Tag': 'noindex, nofollow',
  },
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if (token && token !== undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export default http;
export const api = API_URL;
export const imageBaseUrl = IMAGE_BASE_URL;
export const chatBaseUrl = ChatBaseUrl;
